import { differenceInCalendarDays } from 'date-fns';

/** Days ahead under which an upcoming meeting shows a countdown. */
const COUNTDOWN_MAX_DAYS = 30;

/** Short countdown for an upcoming meeting ("Aujourd'hui", "Demain", "Dans 5 jours"). */
export function getMeetingCountdown(date: Date, now: Date = new Date()) {
  const days = differenceInCalendarDays(date, now);

  if (days < 0 || days > COUNTDOWN_MAX_DAYS) {
    return undefined;
  }

  if (days === 0) {
    return "Aujourd'hui";
  }

  if (days === 1) {
    return 'Demain';
  }

  return `Dans ${days} jours`;
}
